import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Avatar from '@material-ui/core/Avatar';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import TablePagination from '@material-ui/core/TablePagination';

const styles = theme => ({
  card: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    height: 650,
  },
  helpIcon: {
    marginLeft: theme.spacing(1),
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  media: {
    height: 250,
    width: 180,
  },
});

class CardDetails extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 0,
    }

    this.handleChangePage = this.handleChangePage.bind(this);
  }

  handleChangePage = (event, newPage) => {
    this.setState({page: newPage});
  };

  render() {
    const { classes, open, handleClose, cards } = this.props;
    let currentTime = new Date();
    return (
      <React.Fragment>
        <Modal
          className={classes.modal}
          open={open}
          onClose={() => {
            this.setState({page: 0})
            handleClose()
          }}
          closeAfterTransition
          BackdropComponent={Backdrop}
        >
          <Fade in={this.props.open}>
            {cards.length > 1 &&
              <Card className={classes.card}>
                <CardMedia
                  className={classes.media}
                  image={cards[0].preview}
                  title={cards[0].name}
                />
                <CardContent>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell></TableCell>
                      <TableCell>Name</TableCell>
                      <TableCell>Price (ETH)</TableCell>
                      <TableCell>Time Past</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {cards.slice(this.state.page * 5, this.state.page * 5 + 5).map((card, index) => {
                      let cardTime = new Date(card.time);
                      cardTime.setHours(cardTime.getHours() - 8);

                      let diff = currentTime - cardTime;
                      let minutes = Math.floor(diff/60000);
                      let seconds = Math.floor(diff/1000);
                      return (
                        <TableRow hover key={index}>
                          <TableCell><Avatar variant="square" alt={card.name} src={card.thumbnail} /></TableCell>
                          <TableCell>{card.name}</TableCell>
                          <TableCell>{card.price}</TableCell>
                          <TableCell>{minutes > 0 ? minutes + ' mins' : seconds + ' secs'}</TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
                <TablePagination
                  rowsPerPageOptions={[5]}
                  component="div"
                  count={cards.length}
                  rowsPerPage={5}
                  page={this.state.page}
                  onChangePage={this.handleChangePage}
                />
                </CardContent>
              </Card>
            }
          </Fade>
        </Modal>
      </React.Fragment>
    );
  }
}

CardDetails.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CardDetails);